import React from "react";
import "./VideoStudios.css";

const VideoStudios = () => {
  const studioContent = [
    // YouTube videos
    {
      id: "1",
      type: "youtube",
      title: "Kech Show",
      url: "https://youtu.be/G8Had864dg8?feature=shared",
      thumbnail: "https://img.youtube.com/vi/G8Had864dg8/hqdefault.jpg",
      duration: "2:18",
    },
    {
      id: "2",
      type: "youtube",
      title: "Betyaferaw show",
      url: "https://youtu.be/f3Pg4oXdxPo?feature=shared",
      thumbnail: "https://img.youtube.com/vi/f3Pg4oXdxPo/hqdefault.jpg",
      duration: "1:45",
    },
    {
      id: "3",
      type: "youtube",
      title: "Ask me anything",
      url: "https://youtu.be/XSxtD39UfEA?feature=shared",
      thumbnail: "https://img.youtube.com/vi/XSxtD39UfEA/hqdefault.jpg",
      duration: "3:22",
    },
    // Instagram posts
    {
      id: "4",
      type: "instagram",
      title: "Photoshoots for Ke'ti Snacks",
      url: "https://www.instagram.com/p/DCoDzG7BJLw/?igsh=MXdxODA5eTNyNHBjMg==",
      thumbnail: "https://instagram.com/p/DCoDzG7BJLw/media/?size=l",
    },
    {
      id: "5",
      type: "youtube",
      title: "Fendisha News with Markos",
      url: "https://youtu.be/H5s-y_T25uQ?feature=shared",
      thumbnail: "https://img.youtube.com/vi/H5s-y_T25uQ/hqdefault.jpg",
      duration: "1:45",
    },
    {
      id: "5",
      type: "youtube",
      title: "Open Up with Meti",
      url: "https://www.youtube.com/watch?v=bN6gfLwOVmA",
      thumbnail: "https://img.youtube.com/vi/bN6gfLwOVmA/hqdefault.jpg",
      duration: "1:45",
    },
  ];

  return (
    <section className="video-studios-section" id="video-studios-section">
      <div className="container">
        <h2 className="section-title">
          Capturing Excellence — With Our Studios & Gear.
        </h2>
        <p className="section-subtitle">
          Explore shows and projects crafted in our studio.
        </p>

        <div className="content-grid">
          {studioContent.map((item) => (
            <a
              key={item.id}
              href={item.url}
              className={`content-card ${item.type}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`View ${item.title} on ${item.type}`}
            >
              <div className="thumbnail-container">
                <img
                  src={item.thumbnail}
                  alt={`${item.title} thumbnail`}
                  className="content-thumbnail"
                  loading="lazy"
                />
                <div className="platform-icon">
                  {item.type === "youtube" ? (
                    <svg viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
                      />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
                      />
                    </svg>
                  )}
                </div>
                {item.duration && (
                  <span className="duration">{item.duration}</span>
                )}
              </div>
              <div className="content-info">
                <h3 className="content-title">{item.title}</h3>
                <span className="platform-name">
                  {item.type === "youtube" ? "YouTube" : "Instagram"}
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* <div className="cta-container">
          <a href="https://linktr.ee/yourstudio" className="cta-button" target="_blank" rel="noopener noreferrer">
            View All Content
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default VideoStudios;
